import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import ZoneButton from './ZoneButton';
import ZoneButtonsWrapper from './ZoneButtonsWrapper';
import {
  getRelativeHeight,
  getRelativeWidth,
} from '../../components/CardReader/CardReader';

const ButtonBC = styled(ZoneButton)`
  height: 100%;
  margin-left: 17%;
  width: 37%;
`;

const ButtonBCD = styled(ZoneButton)`
  margin-left: 17%;
  height: ${getRelativeHeight(50)};
  width: 54%;
`;

const ButtonDummy = styled(ZoneButton)`
  margin-top: ${getRelativeHeight(-4)};
  width: 0;
`;

const UpButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  right: ${getRelativeHeight(5)};
  height: ${getRelativeHeight(52)};
  width: ${getRelativeWidth(390)};
  margin-top: 11%;
  margin-bottom: ${getRelativeHeight(7)};
`;

const UpButton = styled(ZoneButton)`
  height: ${getRelativeHeight(266)};
  width: ${getRelativeWidth(65)};
  cursor: pointer;
`;

const ZoneButtonsB2 = ({ onClickZoneBC, onClickZoneBCD, onClickUpButton }) => (
  <ZoneButtonsWrapper>
    <UpButtonWrapper>
      <ButtonBC onClick={onClickZoneBC} />
      <UpButton onClick={onClickUpButton} />
    </UpButtonWrapper>
    <ButtonBCD onClick={onClickZoneBCD} />
    <ButtonDummy onClick={() => false} />
  </ZoneButtonsWrapper>
);

ZoneButtonsB2.propTypes = {
  onClickZoneBC: PropTypes.func.isRequired,
  onClickZoneBCD: PropTypes.func.isRequired,
  onClickUpButton: PropTypes.func.isRequired,
};

export default ZoneButtonsB2;
